import { tasks as tasksApi } from '@afosto/messaging/api/Tasks';
import wait from '@afosto/utils/wait';

const MAX_RETRY_ATTEMPTS = 30;
const MINIMUM_WAIT = 300;
const POLL_INTERVAL = 1000;

const pollTask = async (taskId, attempts = 0) => {
  try {
    if (!taskId) {
      return Promise.reject(new Error('No task id provided!'));
    }

    if (attempts === MAX_RETRY_ATTEMPTS) {
      return Promise.reject(new Error('Too many attempts'));
    }

    await wait(MINIMUM_WAIT);

    const response = await tasksApi.getTask(taskId);
    const { data } = response;
    const { is_success: isSuccess = false, percentage, result } = data ?? {};
    const formattedResult = result ? atob(result) : null;

    if (isSuccess) {
      return { result: formattedResult, task: data };
    }

    if (!isSuccess && percentage === 100) {
      const errorData = { result: formattedResult, task: data };
      return Promise.reject(errorData);
    }

    await wait(POLL_INTERVAL);

    return pollTask(taskId);
  } catch (err) {
    if (attempts < MAX_RETRY_ATTEMPTS) {
      return pollTask(taskId, attempts + 1);
    }

    return Promise.reject(err);
  }
};

export default pollTask;
